import React from 'react';
import { FaTimes, FaCheck, FaPrint, FaInfo } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { FiAlertTriangle } from 'react-icons/fi';

const mostrarToast = (type, msg, time) => {
    switch (type) {
        case 'sucesso':
            toast.success(<><FaCheck /> {msg}</>, {
                autoClose: time || 1200
            })
            break;
        case 'erro':
            toast.error(<><FaTimes /> {msg}</>)
            break;
        case 'alerta':
            toast.warning(<><FiAlertTriangle /> {msg}</>,)
            break;
        case 'print-msg':
            toast(<><FaPrint /> {msg}</>, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            break;
        default:
            toast.info(<><FaInfo /> {msg}</>)
    }
}

export { mostrarToast }